import React from 'react';
import { QueryClientProvider, HydrationBoundary } from '@tanstack/react-query';
import { FeaturesProvider } from '@wkda/feature-toggle';
import Cookies from 'universal-cookie';
import { AppConfigurationContainer } from '../hooks/useAppConfiguration';
import { PageDataContainer } from '../hooks/usePageData';
import { ModulesContainer } from '../hooks/useModules';
import TranslationsProvider from '../TranslationsProvider';
import { CookiesProvider } from '../hooks/useCookies';
import { ErrorsProvider } from '../hooks/useResponseErrors/useResponseErrors';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AppContainers(_ref) {
  let {
    features,
    locale,
    appConfig: config,
    initialData,
    modules,
    activateLocale,
    children,
    queryClient,
    req
  } = _ref;
  return /*#__PURE__*/_jsx(QueryClientProvider, {
    client: queryClient,
    children: /*#__PURE__*/_jsx(HydrationBoundary, {
      state: initialData.dehydratedState,
      children: /*#__PURE__*/_jsx(CookiesProvider, {
        cookies: req ? new Cookies(req.headers.cookie) : undefined,
        children: /*#__PURE__*/_jsx(FeaturesProvider, {
          value: {
            config: features,
            locale
          },
          children: /*#__PURE__*/_jsx(AppConfigurationContainer, {
            data: config,
            children: /*#__PURE__*/_jsx(PageDataContainer, {
              data: initialData,
              children: /*#__PURE__*/_jsx(ModulesContainer, {
                data: modules,
                children: /*#__PURE__*/_jsx(ErrorsProvider, {
                  children: /*#__PURE__*/_jsx(TranslationsProvider, {
                    locale: locale,
                    onActivate: activateLocale,
                    children: children
                  })
                })
              })
            })
          })
        })
      })
    })
  });
}